module.exports = __webpack_public_path__ + "static/media/stilly7.5d9bda32.JPG";